import { ReactNode, useEffect } from "react"
import { useInitService } from "@/hooks/init/useInit"
import { createGlobalStore } from "@/stores/global"
import { useAuth } from "@/providers/AuthProvider"

import "@/i18n"

type I18nProviderProps = {
  children: ReactNode
}

export default function I18nProvider(props: I18nProviderProps) {
  const { token } = useAuth()
  const { setToken } = createGlobalStore((state) => ({
    setToken: state.setToken,
  }))

  useEffect(() => {
    if (token) {
      setToken(token)
    }
  }, [token, setToken])

  useInitService(token || "")

  return <>{props.children}</>
}
